import { createFileRoute } from '@tanstack/react-router';

import { WaitlistPage } from '../../portal/waitlist-page';

/** `/account/waitlist` — join or leave the waitlist for an earlier slot (FR-BOOK-16). */
export const Route = createFileRoute('/account/waitlist')({
  component: WaitlistPage,
});
